import type { BeckyModel } from '@wix/thunderbolt-becky-root'

/**
 * Set experiments on the globalThis object, experiments need to be set in the implementation it self.
 *
 **/
export const setGlobalThis = ({ experiments }: BeckyModel) => {
	// @ts-ignore
	globalThis.twoDigitDecimalExperiment = !!experiments['specs.thunderbolt.twoDigitDecimal']
	// @ts-ignore
	globalThis.newSpxResolving = !!experiments['specs.thunderbolt.newSpxResolving']
}

/**
 * Clear globalThis object for the experiments.
 *
 **/
export const clearGlobalThis = () => {
	// @ts-ignore
	delete globalThis.twoDigitDecimalExperiment
	// @ts-ignore
	delete globalThis.newSpxResolving
}
